/**
 * Full-page redirect to an external URL (e.g. the Zitadel authorization URL).
 *
 * Lives behind a module boundary because happy-dom's `location.assign` rewrites
 * `window.location` for the rest of the test file — tests observe the redirect
 * by mocking this module.
 */
export function redirectBrowser(url: string): void {
  window.location.assign(url);
}

/**
 * Like redirectBrowser, but replaces the current history entry. For leaving
 * pages that must not be returned to via Back — e.g. the SSO callback, whose
 * single-use code+state are spent once the exchange ran.
 */
export function redirectBrowserReplacing(url: string): void {
  window.location.replace(url);
}

/**
 * Reload the current document. For full-load continuations whose target IS
 * the current URL: location.assign there would be a same-document (fragment)
 * navigation that never produces the reload the caller needs.
 */
export function reloadBrowser(): void {
  window.location.reload();
}
